export default "__VITE_ASSET__62b4b75a__"